import { SearchInput } from '../shared';
import { SortOrder, DepartmentSortType } from '../enums';

export class GetDepartmentsInput extends SearchInput<DepartmentSortType> {
    constructor() {
        super(DepartmentSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
